



















































import { Component, Model, Prop, Vue } from "vue-property-decorator";

@Component
export default class DfiDialog extends Vue {
  @Model("update:modelValue") visible!: boolean;
  @Prop({ default: "Dialog Title" }) title!: string;
  @Prop({ default: false }) persistent!: boolean;
  @Prop({ default: 480 }) dialogWidth!: number;
  @Prop({ default: true }) closable!: boolean;
  @Prop() subtitle?: string;

  close(): void {
    this.$emit("update:modelValue", false);
  }

  onVisibilityChange(newValue: boolean): void {
    this.$emit("update:modelValue", newValue);
  }
}
